import { Injectable } from '@angular/core';
import {Router, CanActivate, CanLoad, Route} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import {PermissionToolkitService, StorageService} from "front-common-toolkits";
import * as moment from 'moment';
import {AuthenticationService} from "../services/utils/authentication.service";
import { StateService } from '../services/state.service';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as UserActions from "src/app/services/state/actions/user.action";

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
    roleLoaded:boolean = false;
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private storageService: StorageService,
        private notification: NzNotificationService,
        private authenticationService: AuthenticationService,
        private permissionToolkitService: PermissionToolkitService,
        private stateSercice:StateService,
        private store:Store<AppState>
    ) { 
        store.select("roleLoaded").subscribe(res=>{
            this.roleLoaded = res;
        })
    }

    async canActivate() {
        if (this.cookieService.get('token') && this.cookieService.get('token') !== '') {
            // 刷新token的逻辑放到header里了 这边不处理

            // const authTime = this.cookieService.get('authTime');
            // const accessTokenExpireMinutes = this.storageService.getLocalItem('accessTokenExpireMinutes');
            // if (authTime && accessTokenExpireMinutes) {
            //     const timeDiff = moment().diff(moment(authTime), 'm');
            //     if (timeDiff > (accessTokenExpireMinutes > 5 ? accessTokenExpireMinutes - 5 : 5)) {
            //         console.log('间隔时间: ' + timeDiff + '分钟');
            //         console.log('刷新间隔: ' + accessTokenExpireMinutes + '分钟');
            //         this.authenticationService.refreshToken()
            //     }
            // }
            //检查权限是否已加载
            if(!this.roleLoaded){
                await this.stateSercice.loadUserInfo()
                return true;
            }else{
                return true;
            }
            
            
        }
        // not logged in so redirect to login page
        console.log('auth.guard.ts canActivate',this.cookieService.get('token'))

        this.notification.create('error', '登录信息过期', '请重新登录!');
        this.store.dispatch(new UserActions.RemoveUser())
        this.router.navigate(['/login']);
        return false;
    }

    canLoad(route: Route): boolean{
        let result = false;
        const availableSubSystems = this.permissionToolkitService.getAvailableModules();
        if (availableSubSystems) {
            availableSubSystems.forEach(subSys => {
                if (subSys.functionUri.includes(route.path)) {
                    result = true;
                }
            })
        }
        if (!result) {
            this.notification.warning('没有此系统的访问权限', '');
        }
        return result;
    }
}
